import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Constants } from "../constants";

declare var $: any;
declare var google: any;

@Component({
  selector: 'app-forced-dropoff',
  templateUrl: './forced-dropoff.component.html',
  styleUrls: ['./forced-dropoff.component.css']
})
export class ForcedDropoffComponent implements OnInit {
  priceIconForDouble: string = Constants.iconForDoublePrice;
  searchDriver:any;
  status:any = 0;
  getdata:any;
  search:any = '';
  page = 0;
  last_page = true;
  btnShowAfterLoad = false;
  paginatedData: any;
  getdriverData:any;
  noDataFoundSearch = false;
  action_type:string;
  id:string;
  action_data:any;
  filterResultt = 'All';
  orderDetailToReopenOpId :any;
  orderDetailData:any;
  customerDetail:any;
  orderDataDisplay:any;
  droppOffAddress:any;
  userDropDocs:any;
  dineIn:any;
  tableNo:any;
  pickUp:any;
  pickupAddress:any;
  productData:any;
  thirdPartyData:any;
  onDetailDriverData:any;
  returnOrderItems:any;
  returnOrderItemsLength:any;
  orderCreated:any;
  orderBooked:any;
  deliverStartDate:any;
  deliverEndDate:any;
  latitude:any;
  longitude:any;
  city:any = -1;
  getalldata:any;
  serviceCityForOrders = 'Service-All';
  city_list : any;
  private debounceTimer: any; // For debouncing


  constructor(private dataService: DataService) { }
  Show_Forced_dropoff()
  {
    this.dataService.Show_dropoff(window.localStorage.getItem('token'), this.status, this.city, this.page, this.search).subscribe(
      (data:any) => {
        this.getdata = data.items;
        this.last_page = data.last_page;
        this.page = data.page;

      },

      (error) => {
        console.log(error)

      }
    );

  }

  getCities(){
    this.dataService.get_Cities(window.localStorage.getItem('token')).subscribe((data:any)=> {
      this.city_list = data.city_list;

  
    }, (error) => {
      this.city_list = []
      console.log(error)
    })
  }

  //added debouncing into it

  onSearchKeyup(): void {
    // Clear the previous timer to reset the debounce period
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new debounce timer
    this.debounceTimer = setTimeout(() => {
      this.filterSearch();
    }, 300); // 300ms debounce time
  }

  filterSearch()
  {   
    this.last_page = true;
    this.page = 0;
    this.btnShowAfterLoad = false;

    this.dataService.Show_dropoff(window.localStorage.getItem('token'),this.status, this.city, this.page, this.search).subscribe(
      (data:any) => {
        this.getdata = data.items;
        this.getdriverData = data;
          this.last_page = this.getdriverData.last_page;
          this.page++;

          this.btnShowAfterLoad = true;
          if (this.getdata.length === 0) {
            this.noDataFoundSearch = true;
          }
      },
      (error) => {

        console.log('error', error);
      }
    );

  }
  getDriverListByPageFunction()
  {
    //this.last_page = true;
    this.page++;
    this.dataService.Show_dropoff(window.localStorage.getItem('token'),this.status,this.city,this.page, this.search).subscribe(
      (data:any) => {
        this.getdata.push(...data.items);
        this.last_page = data.last_page;
        this.page = data.page;
      },
      (error) => {

        console.log('error', error);
      }
    );

  }
  procceed_fuction(id,i,index)
  {
    this.id = id;
    this.action_type = i;


    this.dataService.Show_aprovedby(window.localStorage.getItem('token'), this.id,this.action_type).subscribe(
      (data) => {
        this.action_data = data;
        this.getdata[index].status = i;
        this.getdata[index].approved_by__admin_profile__first_name = "You"

        // this.Show_Forced_dropoff();
      },
      (error) => {

        console.log('error', error);
      }
    );

  }
  filterResult(getstatus, type = "", random = "")
  {
    this.page = 0;
    this.status = getstatus;
    if(this.status==-1)
    {
      this.filterResultt = 'All';
    }
    else if(this.status==0)
    {
      this.filterResultt = 'Pending';
    }
    else if(this.status==1)
    {
      this.filterResultt = 'Approved';
    }
    else
    {
      this.filterResultt = 'Rejected';
    }
    this.dataService.Show_dropoff(window.localStorage.getItem('token'),this.status,this.city,this.page, this.search).subscribe(
      (data:any) => {
        this.getalldata = data;
        this.getdata = data.items;
        this.last_page = this.getalldata.last_page;
      },
      (error) => {

        console.log('error', error);
      }
      );

  }
  orderDetailCall(id) {

    this.orderDetailToReopenOpId = id;
    this.dataService.getOrderhDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.orderDetailData = data;


        this.customerDetail = this.orderDetailData.customer_detail;
        this.droppOffAddress = this.orderDetailData.dropoff_address;
        // we have to work here
        this.userDropDocs = this.orderDetailData.drop_off_docs;
        this.orderDataDisplay = this.orderDetailData.order;
        let order_type = this.orderDataDisplay.delivery_man_type;
        if (order_type === 4) {
          this.dineIn = true;
          this.tableNo = this.orderDataDisplay.dine_in_table_number;
        } else {
          this.dineIn = false;
          this.tableNo = '';
        }
        if (order_type === 5) {
          this.pickUp = true;
        } else {
          this.pickUp = false;
        }
        this.pickupAddress = this.orderDetailData.pickup_address;
        this.productData = this.orderDetailData.product;
        this.thirdPartyData = this.orderDetailData.third_party;
        this.onDetailDriverData = this.orderDetailData.driver;
        this.returnOrderItems = this.orderDataDisplay.return_items['return_product_list'];
        this.returnOrderItemsLength = this.returnOrderItems.length;
        this.orderCreated = this.orderDetailData.order_created_by;
        this.orderBooked = this.orderDetailData.order_booked_by;
        // console.log('this.orderCreated', this.orderCreated);
        $('#orderDetailPop').modal('show');

        var cDate = new Date().getDate();
        var cYear = new Date().getFullYear();
        var cMonth = new Date().getUTCMonth() + 1;
        var openTime = this.orderDataDisplay.open_time;
        var tOpen = cYear + '/' + cMonth + '/' + cDate + ' ' + openTime + ' ' + 'UTC';
        var dateObjOpen = new Date(tOpen);
        this.deliverStartDate = dateObjOpen;

        var closeTime = this.orderDataDisplay.close_time;
        var tClose = cYear + '/' + cMonth + '/' + cDate + ' ' + closeTime + ' ' + 'UTC';
        var dateObjClose = new Date(tClose);
        this.deliverEndDate = dateObjClose;
      },
      (error) => {

        console.log('error', error);
      }
    );
  }
  // callMap(latitude,longitude)
  // {
  //   console.log('this.latitude , this.longitude', latitude , longitude);
  // }
  getService(getcity)
  {
    this.page = 0;
    if (getcity.city == 'All') {

      this.serviceCityForOrders = 'Services - All';
      getcity.id = -1;
  }
  // else if (getcity == 'Glasgow City')
  // {
  //   this.serviceCityForOrders = getcity;
  // }
  // else if (getcity == 'Renfrewshires')
  // {
  //   this.serviceCityForOrders = getcity;
  // }
  else
  {
    this.serviceCityForOrders = getcity.city;
  }
  this.city = getcity.id;
  this.dataService.Show_dropoff(window.localStorage.getItem('token'), this.status, this.city, this.page, this.search).subscribe(
    (data:any) => {
      this.getdata = data.items;
    },
    (error) => {

      console.log('error', error);
    }
    );
}
  ngOnInit() {
    this.Show_Forced_dropoff();
    this.getCities();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#Dropoff').css('color', '#d77229');
  }
  
  findcustomerDetail(cust_id: string){}

}



// WEBPACK FOOTER //
// ./src/app/forced-dropoff/forced-dropoff.component.ts